import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert, FormSelect } from 'react-bootstrap';
import UOMDataService from "./services/uom.service";
import { Navigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useEffect } from 'react';
import { IoIosArrowBack } from "react-icons/io";

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const EditUOMsPage = (props) => {    
  let params = useParams();
  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const [uomid, setUomid] = useState(params.id);
  const [unitofmeasureabbrev, setUnitofmeasureabbrev] = useState('');
  const [unitofmeasurelongdescription, setUnitofmeasurelongdescription] = useState('');

  const onChangeUnitofmeasureabbrev = (e) => {
    setUnitofmeasureabbrev(e.target.value);
  } 

  const onChangeUnitofmeasurelongdescription = (e) => {
    setUnitofmeasurelongdescription(e.target.value);
  } 

  const handleValidations = (e) => {
    if (unitofmeasureabbrev.length == 0) {
      setErrmessage('There are empty required fields.');
      setShowerror(true);
      return;
    }
    saveUOM();
  }

  useEffect(() => {
    retrieveUOM(uomid);  
  }, [])

  const retrieveUOM = (uomid) => {
    UOMDataService.get(uomid)
      .then(response => {
        setUnitofmeasureabbrev(response.data.unitofmeasureabbrev);
        setUnitofmeasurelongdescription(response.data.unitofmeasurelongdescription);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }


  let saveUOM = ()  =>{   
    var data = {
        unitofmeasureabbrev: unitofmeasureabbrev,
        unitofmeasurelongdescription: unitofmeasurelongdescription
    }    
    
    UOMDataService.update(params.id, data)
    .then(response => {
      setSubmitted(true);
      setSuccmessage('UOM has been updated. Redirecting to uom list...');
      setShowsuccess(true);
      window.location.assign('/uoms');
    })
    .catch(e => {
      console.log(e);
    })        
  }  

  const goToUOMssList = (e) => {
    window.location.assign('/uoms')
  }
  
  return (
    <>
      <Container style={{width:"80%"}}>
        <Row className='mb-2'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Edit UOM</h4>
          <Col lg={true}>
            <FormLabel className='mb-2'>UOM Name:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="unitofmeasureabbrev" id="unitofmeasureabbrev" onChange={onChangeUnitofmeasureabbrev} defaultValue={unitofmeasureabbrev}></FormControl>
          </Col>

          <Col lg={true}>
            <FormLabel className='mb-2'>UOM Long Description:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="unitofmeasurelongdescription" id="unitofmeasurelongdescription" onChange={onChangeUnitofmeasurelongdescription} defaultValue={unitofmeasurelongdescription}></FormControl>
          </Col>          

        </Row>
        <hr/>
        <Row className='mb-2'>
          <Col className='col-md-3'>
            <Button id='saveItem' onClick={handleValidations}>Save UOM</Button>            
            <Button className='m-2' id='backToUOMsList' onClick={goToUOMssList}><IoIosArrowBack/></Button>            
          </Col>
        </Row>  
        {showerror && (
          <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
            <Alert.Heading>Error</Alert.Heading>
            <p>{errmessage}</p>
          </Alert>      
        )}
        {showsuccess && (
          <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
            <Alert.Heading>Done</Alert.Heading>
            <p>{succmessage}</p>
          </Alert>      
        )}     
         {submitted ? (<Navigate push to="/uoms"/>) : null }                                     
      </Container>    
    </>
  )

}

export default EditUOMsPage;

